<template>
  <div class="relative lg:px-12 md:px-12 px-4">
    <img src="@/assets/images/line/Vector 7.png" alt="lineimg" class="m-auto" />
    <!-- <div class="absolute bg-design4 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd4.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <div class="absolute bg-design5 mob-hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div> -->
    <div class="lg:flex md:flex items-center sm-displayflex">
      <!-- temp-h950 md-temp-h400 -->
      <div
        class="lg:w-1/2 md:w-1/2 w-full lg:pr-0 md:pr-10 lg:pt-0 md:pt-0 pt-5"
      >
        <div class="">
          <!-- faded faded-left faded-top faded-bottom faded-right -->
          <!-- src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Aboutus.webp" -->
          <!-- src="@/assets/images/About ushome.jpg" -->
          <img
            :src="`${$imageURL}/${aboutUs.result[0].image}`"
            alt="aboutus"
            class="m-auto custborderradius h-330px sm-h250px sm-wfull"
          />
        </div>
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full">
        <div class="">
          <p
            class="title-home md-fsize30 sm-fsize16 md:font-normal lg:font-normal font-bold"
          >
            <!-- About Us -->
            {{ aboutUs.result[0].heading }}
          </p>
          <!-- <p class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13">
            Caregiver Saathi is an ecosystem that enables compassionate caring,
            while also addressing the needs of the caregiver and their overall
            well-being.
            <span class=""
              >A one-stop platform, where family and professional caregivers
              access learning tools, safe support groups, a community of
              experienced caregivers and a range of curated services for
              home-based care.</span
            >
          </p> -->
          <!-- <p class="subtitle lg:pt-8 md:pt-8 lg:pt- 4 md:pt-4 pt-2 lh32px sm-fsize13 sm-lh26  mob-hidden">
            We offer services that provide family caregivers necessary guidance
            through emotional aid, educational content, access to a community of
            experienced caregivers, support groups & counselling, and
            professional services for home based care that you may need during
            your caregiving journey.
          </p> -->
          <!-- <p
            class="subtitle md-fsize16 lg:pt-0 md:pt-0 pt-2 lh30px sm-lh26 sm-fsize13"
          >
            Caregiver Saathi™ is an ecosystem that enables compassionate caring.
            We provide family caregivers community support, learning tools and a
            range of curated services for home-based care. Our offerings aim to
            ease the caregiving challenges of families dealing with long-term
            care of patients with chronic health conditions and aid caregiver
            well-being.
          </p> -->
          <p
            class="subtitle md-fsize18 lg:pt-0 md:pt-0 pt-2 lh32px sm-lh26 sm-fsize13"
          >
            <span v-html="aboutUs.result[0].description"></span>
          </p>
        </div>
        <div class="lg:pt-8 md:pt-6 pt-4">
          <base-button
            outline
            type="primary"
            class="md:px-8 lg:px-8 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2"
            @click="handleClick('about-us')"
            >Read More</base-button
          >
          <!-- <base-button
            outline
            type="primary"
            class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2 bg-white"
            @click="handleClick('about-us')"
            >Read More</base-button
          > -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  async mounted() {
    await this.$store.dispatch("homepage/getall_aboutUs");
  },
  computed: {
    ...mapState("homepage", { aboutUs: "aboutUs" }),
  },
};
</script>
